module.exports = __webpack_public_path__ + "img/bloodtainted-greatsword.75fdd44e.webp";